import React, { useEffect } from 'react';
import { setDeploymentTypeTypeContains } from 'redux/services/julia/productCatalogParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';
import { FancyInput } from '../Inputs';

export const DeploymentTypeFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setDeploymentTypeTypeContains(value || undefined));
  }, 500);

  // Clears state on unmount
  useEffect(() => {
    return (): void => {
      dispatch(setDeploymentTypeTypeContains(undefined));
    };
  }, [dispatch]);

  return <FancyInput placeholder="Deployment Type" onChange={handleChange} />;
};
